module.exports = __webpack_public_path__ + "6c4a0dbc/img/rename-icon.de4e673d.svg";